import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import "./builderToolbarMenuSubViewList.scss";

export interface IBuilderToolbarMenuSubViewListOption<TId extends string = string> {
  id: TId;
  title: string;
}

interface IBuilderToolbarMenuSubViewListProps<TId extends string = string> {
  options: IBuilderToolbarMenuSubViewListOption<TId>[];
  onSelect: (id: TId) => void;
}

export function BuilderToolbarMenuSubViewList<TId extends string = string>(
  props: IBuilderToolbarMenuSubViewListProps<TId>,
) {
  const { options, onSelect } = props;

  return (
    <div className="builder-toolbar-menu-sub-view-list">
      {options.map(option => (
        <button
          key={option.id}
          type="button"
          className="builder-toolbar-menu-sub-view-list-option"
          onClick={() => onSelect(option.id)}
        >
          <span className="builder-toolbar-menu-sub-view-list-option-title">{option.title}</span>
          <FontAwesomeIcon
            className="builder-toolbar-menu-sub-view-list-option-chevron"
            icon={faChevronRight}
            aria-hidden="true"
          />
        </button>
      ))}
    </div>
  );
}
